import { render, staticRenderFns } from "./LoadData.vue?vue&type=template&id=3f3595c1&"
import script from "./LoadData.vue?vue&type=script&lang=js&"
export * from "./LoadData.vue?vue&type=script&lang=js&"
import style0 from "./LoadData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports